import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {  useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";

import api from "../service/api";

import BuscadorOrganismo from "../commons/BuscadorOrganismo";
import BuscadorPersonaFisica from "../commons/BuscadorPersonaFisica";
import BuscadorPersonaJuridica from "../commons/BuscadorPersonaJuridica";
import { setError,setSuccess } from "../reducers/appSlice";
import { TextField } from "@mui/material";

const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const AgregarIniciador = ({ tramite_id, actualizarDatos, disable}) => {
  

  const [submitting, setSubmitting] = useState(false);

  const [personaFisica, setPersonaFisica] = useState(null);
  const [personaJuridica, setPersonaJuridica] = useState(null);
  const [organismo, setOrganismo] = useState(null);
  const dispatch = useDispatch();
  const validationSchema = Yup.object({
    tipoIniciador: Yup.number().positive("Requerido").required("Requerido"),
    nombreIniciador: Yup.string().required("Requerido"),
    email: Yup.string().email("Email inválido").required("Requerido"),
  });
  
  const limpiarIniciadorSeleccionado = () => {
    setPersonaFisica(null);
    setPersonaJuridica(null);
    setOrganismo(null);
  };
  
  const formik = useFormik({
    initialValues: {
      tipoIniciador: 0,
      nombreIniciador: "",
      email: "",
    },

    validationSchema:validationSchema,

    onSubmit: async (values) => {
        setSubmitting(true);
      const tipoIniciador = Number(values.tipoIniciador);

      let personaId = null;
      let organismoId = null;

      if (tipoIniciador === 1) {
        personaId = personaFisica?.id;
      }

      if (tipoIniciador === 2) {
        personaId = personaJuridica?.id;
      }

      if (tipoIniciador === 3) {
        organismoId = organismo?.id;
      }
      api.guardarIniciador ({
        tramite_id:tramite_id,
        personaId: personaId,
        organismoId:organismoId,
        dmc_id:null,
        tdm_id:null,
        localidad_id:null,
        barrio_id:null,
        cll_id:null,
        numeracion:null,
        piso:null,
        depto:null,
        referencias:null,
        email:values.email}).
        then((res) => { 
            actualizarDatos();
            formik.setFieldValue("email", "");
            formik.setFieldError("email", undefined);
            formik.setFieldTouched("email", false);
            formik.setFieldValue("nombreIniciador", "");
            formik.setFieldError("nombreIniciador", undefined);
            formik.setFieldTouched("nombreIniciador", false);
            dispatch(setSuccess("Iniciador guardado"));
        })
        .catch((e) => dispatch(setError("Error al guardar iniciador")))
        .finally(() => setSubmitting(false));
    },
  });

  /*
   * Cuando cambia el tipo, se limpia cualquier selección anterior.
   */
  const handleTipoIniciador = async (event) => {
    const tipo = Number(event.target.value);
  
    limpiarIniciadorSeleccionado();
  
    await formik.setFieldValue("tipoIniciador", tipo);
    formik.setFieldTouched("tipoIniciador", true, false);
  
    if (tipo !== 0) {
      formik.setFieldError("tipoIniciador", undefined);
    }
    formik.setFieldValue("email", "");
    formik.setFieldValue("nombreIniciador", "");
    formik.setFieldError("nombreIniciador", undefined);
    formik.setFieldTouched("nombreIniciador", false);
  };
  const handleFisicas = async(fisica) => {
    setPersonaFisica(fisica);
    setPersonaJuridica(null);
    setOrganismo(null);

    const nombreCompleto = [
      fisica?.nombres,
      fisica?.apellido,
    ]
      .filter(Boolean)
      .join(" ");
      await formik.setFieldValue("nombreIniciador",nombreCompleto,false);
      await formik.setFieldTouched("nombreIniciador",true,false);
      formik.validateField("nombreIniciador");
  };

  const handleJuridicas = async(juridica) => {
    setPersonaFisica(null);
    setPersonaJuridica(juridica);
    setOrganismo(null);

    const nombre =
      juridica?.razonSocial ||
      juridica?.nombre ||
      "";

      await formik.setFieldValue("nombreIniciador",nombre,false);
      await formik.setFieldTouched("nombreIniciador",true,false);
      formik.validateField("nombreIniciador");
  };

  const handleOrganismos =async(organismoSeleccionado) => {
    setPersonaFisica(null);
    setPersonaJuridica(null);
    setOrganismo(organismoSeleccionado);

    const nombre =
      organismoSeleccionado?.descOrgCompleta ||
      organismoSeleccionado?.nombre ||
      "";

      await formik.setFieldValue("nombreIniciador",nombre,false);
      await formik.setFieldTouched("nombreIniciador",true,false);
      formik.validateField("nombreIniciador");
  };
 
  /*
   * Sirve para limpiar el nombre si el buscador elimina la selección.
   */
  useEffect(() => {
    const tipo = Number(formik.values.tipoIniciador);

    if (tipo === 1 && !personaFisica) {
      formik.setFieldValue("nombreIniciador", "");
    }
   

    if (tipo === 2 && !personaJuridica) {
      formik.setFieldValue("nombreIniciador", "");
    }

    if (tipo === 3 && !organismo) {
      formik.setFieldValue("nombreIniciador", "");
    }
  }, [
    personaFisica,
    personaJuridica,
    organismo,
    formik.values.tipoIniciador,
  ]);
  
  const tipoIniciador = Number(formik.values.tipoIniciador);
  return (
    <form
      id="formAltaIniciador"
      name="formAltaIniciador"
      onSubmit={formik.handleSubmit}
      onReset={formik.handleReset}
      noValidate
      autoComplete="off"
    >
      <Row container spacing={1} sx={{ mt: 1, alignItems: "flex-start" }}>
  {/* Tipo */}
  <Grid item xs={12} sm={6} md={3} lg={2}>
    <FormControl
      variant="outlined"
      size="small"
      fullWidth
      disabled={disable}
      error={
        formik.touched.tipoIniciador &&
        Boolean(formik.errors.tipoIniciador)
      }
    >
      <InputLabel id="tipoIniciadorLabel"> Tipo de iniciador</InputLabel>
      <Select
        labelId="tipoIniciadorLabel"
        id="tipoIniciador"
        name="tipoIniciador"
        label="Tipo de iniciador"
        value={formik.values.tipoIniciador}
        onChange={handleTipoIniciador}
        onBlur={formik.handleBlur}
      >
        <MenuItem value={0}>
          <em>Seleccione</em>
        </MenuItem>
        <MenuItem value={1}>Persona física</MenuItem>
        <MenuItem value={2}>Persona jurídica</MenuItem>
        <MenuItem value={3}>Organismo</MenuItem>
      </Select>
      <FormHelperText>
        {formik.touched.tipoIniciador
        ? formik.errors.tipoIniciador
        : ""}
      </FormHelperText>
    </FormControl>
  </Grid>

  {/* Iniciador */}
  <Grid item xs={12} sm={6} md={3} lg={6}>
    {(tipoIniciador === 0 || tipoIniciador === 1) && (
      <TextField
        fullWidth
        id="nombreIniciador"
        name="nombreIniciador"
        value={formik.values.nombreIniciador}
        label="Iniciador"
        variant="outlined"
        size="small"
        disabled
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <BuscadorPersonaFisica
                resultado={handleFisicas}
                activo="S"
                mostrar="n"
                disabled={submitting === true && tipoIniciador===0 ?true:submitting === false && tipoIniciador===0?true:false}
              />
            </InputAdornment>
          ),
        }}
        error={
          formik.touched.nombreIniciador &&
          Boolean(formik.errors.nombreIniciador)
        }
        helperText={
          formik.touched.nombreIniciador &&
          formik.errors.nombreIniciador
        }
      />
    )}

    {tipoIniciador === 2 && (
      <TextField
        fullWidth
        id="nombreIniciador"
        name="nombreIniciador"
        value={formik.values.nombreIniciador}
        label="Iniciador"
        variant="outlined"
        size="small"
        disabled
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <BuscadorPersonaJuridica
                resultado={handleJuridicas}
                activo="S"
                mostrar="n"
                disabled={submitting}
              />
            </InputAdornment>
          ),
        }}
        error={
          formik.touched.nombreIniciador &&
          Boolean(formik.errors.nombreIniciador)
        }
        helperText={
          formik.touched.nombreIniciador &&
          formik.errors.nombreIniciador
        }
      />
    )}

    {tipoIniciador === 3 && (
      <TextField
        fullWidth
        id="nombreIniciador"
        name="nombreIniciador"
        value={formik.values.nombreIniciador}
        label="Iniciador"
        variant="outlined"
        size="small"
        disabled
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <BuscadorOrganismo
                resultado={handleOrganismos}
                mostrar="n"
                accion="consulta"
                disabled={submitting}
              />
            </InputAdornment>
          ),
        }}
        error={
          formik.touched.nombreIniciador &&
          Boolean(formik.errors.nombreIniciador)
        }
        helperText={
          formik.touched.nombreIniciador &&
          formik.errors.nombreIniciador
        }
      />
    )}
  </Grid>
  {/* Email */}
  <Grid item xs={12} sm={6} md={2} lg={3}>
    <TextField
      fullWidth
      id="email"
      name="email"
      type="email"
      value={formik.values.email || ""}
      label="Email"
      variant="outlined"
      size="small"
      disabled={disable}
      onChange={formik.handleChange}
      error={
        formik.touched.email &&
        Boolean(formik.errors.email)
      }
      helperText={
        formik.touched.email &&
        formik.errors.email
      }
    />
  </Grid>

  {/* Botón */}
  <Grid item xs={12} sm={12} md={1} lg={1} 
    sx={{ 
      display: "flex",
      justifyContent: {xs: "flex-start",  md: "center", },
    }}
  >
    <IconButton
      color="primary"
      type="submit"
      disabled={disable}
      title="Agregar iniciador"
      sx={{
        width: 40,
        height: 40,
      }}
    >
      <DoneOutlineRounded />
    </IconButton>
  </Grid>
</Row>
    </form>
  );
};

export default AgregarIniciador;